/**
 * Project Categories Configuration
 * Defines categories with icons and colors for project filtering
 */

import { 
  GiBrain, GiArtificialIntelligence 
} from 'react-icons/gi';
import { HiGlobeAlt, HiCloud, HiShieldCheck, HiChatBubbleLeftRight, HiEye } from 'react-icons/hi2';
import { TbCpu, TbDatabaseCog, TbChartInfographic, TbChartDots3, TbDevices } from 'react-icons/tb';
import type { ProjectCategory, ProjectCategoryConfig } from '@/types';

export const projectCategories: Record<ProjectCategory, ProjectCategoryConfig> = {
  "Web Development": { 
    icon: HiGlobeAlt, 
    color: "text-emerald-500" 
  },
  "Systems Programming": { 
    icon: TbCpu, 
    color: "text-green-500" 
  },
  "Cloud Computing": { 
    icon: HiCloud, 
    color: "text-sky-500" 
  },
  "Database Systems": { 
    icon: TbDatabaseCog, 
    color: "text-teal-500" 
  },
  "Machine Learning": { 
    icon: GiBrain, 
    color: "text-purple-500" 
  },
  "Big Data": { 
    icon: TbChartInfographic, 
    color: "text-blue-500" 
  },
  "Cybersecurity": { 
    icon: HiShieldCheck, 
    color: "text-red-500" 
  },
  "Deep Learning": { 
    icon: GiArtificialIntelligence, 
    color: "text-indigo-500" 
  },
  "NLP": { 
    icon: HiChatBubbleLeftRight, 
    color: "text-pink-500" 
  },
  "Data Science": { 
    icon: TbChartDots3, 
    color: "text-orange-500" 
  },
  "IoT": { 
    icon: TbDevices, 
    color: "text-cyan-500" 
  },
  "Computer Vision": { 
    icon: HiEye, 
    color: "text-yellow-500" 
  }
};

